import { useTranslation } from 'react-i18next';
import { useUi } from '../state/ui';
import type { Readiness } from './providers';

/** Why an AI feature cannot run yet, with the way to the settings that fix it. */
export function AiNotReady({ status }: { status: Readiness }) {
  const { t } = useTranslation();
  const set = useUi((s) => s.set);
  return (
    <div className="flex flex-col items-start gap-2 text-sm text-fg-muted">
      <p>{t(`ai.notReady.${status}`)}</p>
      <button
        type="button"
        onClick={() => set({ settingsOpen: true, settingsTab: 'ai' })}
        className="rounded-lg border border-border px-2 py-1 text-fg hover:bg-bg-hover"
      >
        {t('ai.openSettings')}
      </button>
    </div>
  );
}
